import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
	type ListNotificationsResponse,
	listNotifications,
	markAllNotificationsRead,
	markNotificationRead,
} from "@/adapters/api";
import {
	markAllReadInCache,
	markReadInCache,
} from "@/features/notifications/utils/cache.ts";

const notificationsKey = ["notifications"];
const PAGE_SIZE = 50;

export function useNotifications() {
	return useQuery({
		queryKey: notificationsKey,
		queryFn: () => listNotifications({ pageSize: PAGE_SIZE }),
		refetchInterval: 30_000,
	});
}

export function useMarkNotificationRead() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => markNotificationRead(id),
		onSuccess: (_data, id) => {
			queryClient.setQueryData<ListNotificationsResponse>(
				notificationsKey,
				(data) =>
					data ? markReadInCache(data, id, new Date().toISOString()) : data,
			);
		},
	});
}

export function useMarkAllNotificationsRead() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: () => markAllNotificationsRead(),
		onSuccess: () => {
			queryClient.setQueryData<ListNotificationsResponse>(
				notificationsKey,
				(data) =>
					data ? markAllReadInCache(data, new Date().toISOString()) : data,
			);
		},
	});
}
